// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"572":"88521a54","944":"49f2f8d1"}[chunkId] + ".chunk.css";
};